import PartnersPortal from './partners-portal';

function App() {
  return <PartnersPortal />;
}

export default App;
